export const snkd = {
  /* 基础系统 */
  foundation: {
    area: {
      listByParentId: "/api/foundation/area/listByParentId",
    },
    file: {
      encryptParam: "/api/foundation/file/encryptParam",
      upload: "/api/foundation/fileAccess/upload",
    },
  },
  /* 生产系统*/
  produce: {
    /**
     * ai窗口判断
     */
    farmsModules: {
      getFarmModulesByCode: "/api/produce/co/farmsModules/getFarmModulesByCode",
    },
    /**
     * 数据上链接口
     */
    dataUplink: {
      add: "/api/produce/co/uploadBlockchainLandConfig/insertAndUpdate",
      list: "/api/produce/co/uploadBlockchainLandConfig/getSumCount",
      detail: "/api/produce/co/uploadBlockchainLandConfig/get",
      uplinkCropList: "/api/produce/co/uploadBlockchainLandConfig/getList",
      delUplinkCrop: "/api/produce/co/uploadBlockchainLandConfig/delete",
    },
    /** 补贴接口 */
    subsidyStatics: {
      list: "/api/produce/co/subsidyStatics/list",
      detail: "/api/produce/co/subsidyStatics/detail",
    },
    // 金融信息
    companyFinanceInfo: {
      selectData: "/api/produce/co/companyFinanceInfo/selectData",
      add: "/api/produce/co/companyFinanceInfo/commit",
      detail: "/api/produce/co/companyFinanceInfo/get",
    },
    /** 合格证接口 */
    certificate: {
      getStorageList:
        "/api/produce/co/warehouseData/getCertificateAndAttrListList",
      getstorageDetail: "/api/produce/co/warehouseData/getList",
      getDetail: "/api/produce/co/certificate/queryCertificateDetail",
      getList: "/api/produce/co/certificate/queryByPrintStatus",
      getListCount: "/api/produce/co/certificate/queryByPrintStatusCount",
      getSnmQrcodeUrl: "/api/nongwei/co/lxsnm/getQRCodeUrl",
      addQrcodeUrl: "/api/produce/co/certificate/addQRCodeURL",
      getQrcodeUrl: "/api/produce/co/certificate/getQRCodeUrl",
      getStationList: "/api/print/co/station/listBind",
      unBindStation: "/api/print/co/station/unBind",
      chooseDefaultStation: "/api/print/co/station/chooseDefault",
      queryCertificateDetailList:
        "/api/produce/co/certificate/queryCertificateDetailList",
      // 添加合格证二维码短链接
      addCertificateQRCodeShortLink: "/api/produce/co/shortLink/add",
      // 合格证(白名单相关配置)
      shangHaiCertificateWhiteConfig: "/api/produce/co/white/config/detail",
      getQRCodeUrls: "/api/produce/co/certificate/getQRCodeUrls",
    },
    /** 合格证打印批次相关接口 **/
    task: {
      generatePrintRecord:
        "/api/produce/co/certificate/task/generatePrintRecord",
      generateTask: "/api/produce/co/certificate/task/generateTask",
      pageCertificateByTask:
        "/api/produce/co/certificate/task/pageCertificateByTask",
      getPageTask: "/api/produce/co/certificate/task/pageTask",
      getPageTaskDetail: "/api/produce/co/certificate/task/pageTaskDetail",
      queryPrintTaskDetail:
        "/api/produce/co/certificate/task/queryPrintPageByTask",
    },
    // 仓储加工
    storageProcess: {
      InputWarehouseData:
        "/api/produce/co/warehouseData/addAndUpdate/InputWarehouseData", //入仓
      OutputWarehouseData:
        "/api/produce/co/warehouseData/addAndUpdate/OutputWarehouseData", //出仓
      OutputProcessData:
        "/api/produce/co/warehouseData/addAndUpdate/OutputProcessData", //加工
      ProcessInspectReport:
        "/api/produce/co/warehouseData/addAndUpdate/ProcessInspectReport", //检测报告
      ProductCodeInfo:
        "/api/produce/co/warehouseData/addAndUpdate/addAndUpdateProcessBindData", //物码信息
    },
    //鸡蛋-仓储加工
    storageProcessEgg: {
      productList: "/api/produce/animalEntryInfo/getProductListByFarmCrop ", //成品名称下拉列表
      getStorageEggDetail:
        "/api/produce/co/warehouseData/getOutputProcessDataList", //加工信息列表
      getProcessInspectReportList:
        "/api/produce/co/warehouseData/getProcessInspectReportList", //检测信息查看
      addOutputProcessData:
        "/api/produce/co/warehouseData/addOutputProcessData", //添加加工
      ProcessInspectReportEgg:
        "/api/produce/co/warehouseData/addProcessInspectReport", //添加检测报告
    },
    seedSourceManagement: {
      pageList: "/api/produce/co/productSourceInfo/pageList",
      listUnit: "/api/produce/co/agriResSku/listUnit",
      agriResPackUnit: "/api/produce/co/agriResPackUnit/list", //单位列表
      insertOrUpdate: "/api/produce/co/productSourceInfo/insertOrUpdate",
      listAll: "/api/produce/co/cropSubject/listAll",
      listCropCategory: "/api/produce/co/crop/listCropCategory/",
      selectList: "/api/produce/co/crop/select/list",
      getById: "/api/produce/co/productSourceInfo/getById/",
      deleteByIds: "/api/produce/co/productSourceInfo/deleteByIds",
    },

    /**神农口袋销售模块 */
    sellRecord: {
      add: "/api/produce/co/sell/batchSell/add",
      downloadstock: "/api/produce/co/stock/download/stock/",
      sellEnterpriseadd: "/api/produce/co/sellEnterprise/add",
      check: "/api/produce/co/sell/batchSell/check",
      addImg: "/api/produce/co/sell/batchSell/addDocumentImgs",
      detail: "/api/produce/co/delivery/goods/record/document/",
      record_detail: "/api/produce/co/delivery/goods/record/detail/",
      urlCompanyList: "/api/produce/co/supplyEnterprise/list",
    },
    mission: {
      missionCategoryList: "/api/produce/co/mission/stash/missionCategoryList",
      list: "/api/produce/co/mission/stash/list",
      detail: "/api/produce/co/mission/stash/getByEdit",
      edit: "/api/produce/co/mission/stash/edit",
      del: "/api/produce/co/mission/stash/del",
      batchDel: "/api/produce/co/mission/stash/batchDel",
      audit: "/api/produce/co/mission/stash/audit",
      batchAudit: "/api/produce/co/mission/stash/batchAudit",
      autoAuditByDay: "/api/produce/co/mission/stash/autoAuditByDay",
      save: "/api/produce/co/mission/stash/edit",
      saveAndAudit: "/api/produce/co/mission/stash/audit",
    },
    //农资
    agricProduct: {
      getAgriResReceiveSkuList: "/api/produce/co/agriResReceiveSku/list", //已出库待使用
      getAgriListSummary: "/api/produce/co/agri/res/listSummary", //系统农资
      add: "/api/appconfig/co/agriRes/feedback/apply", //添加农资
      outsourcingInfoAdd: "/api/produce/co/outsourcingInfo/add", //外采信息录入
      supplyEnterpriseAdd: "/api/produce/co/supplyEnterprise/add",
    },
    farm: {
      get: "/api/produce/co/farm/get",
      list: "/api/produce/co/farm/list",
      statisticsFarmAcreAndOnPlantingAcre:
        "/api/produce/co/farm/statisticsFarmAcreAndOnPlantingAcre",
      sumAwaitInsureOrderLandAcre:
        "/api/produce/co/land/sumAwaitInsureOrderLandAcre",
      getMap: "/api/produce/co/farm/get/map",
      onPlantingByFarmId: "/api/produce/co/farm/onPlantingByFarmId", // 种养品种
      queryByFarmId: "/api/produce/co/greenFoodCertificate/queryByFarmId", // 绿色认证
    },
    farmScoreDetail: {
      getScore: "/api/produce/co/farmScoreDetail/getScore",
    },
    damage: {
      list: "/api/produce/co/LandDisasterReport/disaster/list",
      sum: "/api/produce/co/LandDisasterReport/sum",
      landList: "/api/produce/co/LandDisasterReport/list",
      add: "/api/produce/co/LandDisasterReport/report/add",
      repeatBatch: "/api/produce/co/LandDisasterReport/report/repeatBatch",
      repeat: "/api/produce/co/LandDisasterReport/report/repeat",
      get: "/api/produce/co/LandDisasterReport/report/get",
      raisedLevel: "/api/produce/co/LandDisasterReport/report/raisedLevel",
      chooseLandList: "/api/produce/co/LandDisasterReport/land/listRefuseLand",
    },
    crop: {
      listAll: "/api/produce/co/crop/listAll",
      listOfCurrency: "/api/produce/co/crop/listOfCurrency", // 作物列表
      listOfCropByFarmId: "/api/produce/co/farm/onPlantingByFarmId",
      plantStandardList: "/api/produce/co/plantStandard/list", //获取种植标准列表
      cropIdList: "/api/produce/co/goods/list/cropid",
      crop: "/api/produce/co/crop/get",
      addCrop: "/api/produce/co/goods/add",
      // 采收库存-作物最晚采收日期
      getLatestPickTime: "/api/produce/co/crop/getLatestPickTime",
      // 外采库存-作物最晚采收日期
      getLatestOutsourcingTime: "/api/produce/co/crop/getLatestOutsourcingTime",
      listAllShort: "/api/produce/co/crop/listAllShort",
      addFeedback: "/api/appconfig/co/crop/feedback/add",
      getListByLayered: "/api/produce/co/crop/listByLayered", //获取农作物列表（含热门列表） v2.5.0新增
    },
    insure: {
      list: "/api/produce/co/insure/list",
    },
    land: {
      getLandGroup: "/api/produce/co/landGroup/landGroupByFarmId", //获取地块分组
      checkEnableByFarmIdAndInsureId:
        "/api/produce/co/land/checkEnableByFarmIdAndInsureId",
      listInsureOrderLand: "/api/produce/co/land/listInsureOrderLand",
      getLandList:
        "/api/produce/co/LandDisasterReport/land/listFarmLandSelected", //地块列表
    },
    farmInsure: {
      add: "/api/produce/co/farm/insure/add",
      getByFarmId: "/api/produce/co/farm/insure/getByFarmId",
      getInsureById: "/api/produce/co/farm/insure/getInsureById",
    },
    // 保单模块
    farmInsurePolicy: {
      get: "/api/produce/co/farm/insure/policy/get",
      listSummary: "/api/produce/co/farm/insure/policy/listSummary",
      // 可投保作物
      listSelectCropGroup:
        "/api/produce/co/farm/insure/policy/listSelectCropGroup",
      // 可投保地块
      listSelectLand: "/api/produce/co/farm/insure/policy/listSelectLand",
      policyOverview: "/api/produce/co/farm/insure/policy/policyOverview",
      insureCalendarFifteenDayList:
        "/api/produce/co/farm/insure/policy/insureCalendarFifteenDayList",
    },
    // 投保订单模块
    farmInsureOrder: {
      add: "/api/produce/co/farm/insure/order/add",
      listSummary: "/api/produce/co/farm/insure/order/listSummary",
      get: "/api/produce/co/farm/insure/order/get",
      checkMinAcre: "/api/produce/co/farm/insure/order/checkMinAcre",
      cancel: "/api/produce/co/farm/insure/order/cancel",
      getPayUrl: "/api/produce/co/farm/insure/order/getPayUrl",
      offlinePayment: " /api/produce/co/farm/insure/order/offlinePayment",
      addPerson: "/api/produce/co/farm/insure/add",
      personList: "/api/produce/co/farm/insure/getByFarmId",
      editPerson: "/api/produce/co/farm/insure/update",
      delPerson: "/api/produce/co/farm/insure/removeById",
      policyholderInfo:
        "/api/produce/co/farm/insure/order/getWhiteListByCompanyId",
      policyholderAdd: "/api/produce/co/farm/insure/add",
      policyholderUpdate: "/api/produce/co/farm/insure/update",
      policyholderGetByFarmId: "/api/produce/co/farm/insure/getByFarmId",
    },
    // 投保银行
    insureBank: {
      bankList: "/api/produce/co/insure/bank/list",
      branchList: "/api/produce/co/insure/bank/branch/list",
    },
    token: {
      get: "/api/produce/co/shgis/getToken",
      getSnToken: "/api/produce/co/gisToken/getGisToken",
    },
    //穗优保险模块
    ruralInsurance: {
      listSYInsurerLand: "/api/produce/co/land/listSYInsurerLand", //地块列表
      listInsureOrderLand: "/api/produce/co/land/listInsureOrderLand", //穗优投保地块
      ruralInsuranceList: "/api/produce/co/insurance/record/list", //穗优保单列表
      ruralGetDetail: "/api/produce/co/insurance/record/detail", // 保单人信息详情
      ruralLandDetail: "/api/produce/co/insurance/record/landDetail", //保单地块详情
      insureOrderListSummary: "/api/produce/co/farm/insure/order/listSummary", // 投保意向单记录
      insureOrderDetail: "/api/produce/co/farm/insure/order/get", // 投保意向单信息 | 投保地块信息
      insureGetByFarmId: "/api/produce/co/farm/insure/getByFarmId", // 投保人信息(投保意向单)
      addInsurance: "/api/produce/co/farm/insure/order/addSY", //添加意向单
    },
    iotAccess: {
      // 摄像头列表
      cameraList: "/api/produce/co/iotAccess/camera/list",
      getLiveUrl: "/api/produce/co/iotAccess/camera/getLiveUrl",
      // 网关列表
      deviceList: "/api/produce/co/iotAccess/device/list",
      // 网关详情
      deviceDetail: "/api/produce/co/iotAccess/device/detail",
      // 指标详情
      propertyGet: "/api/produce/co/iotAccess/device/property/get",
      // 指标历史数据
      devicePropertyHistory:
        "/api/produce/co/iotAccess/device/property/history",
    },
    // 农场经营实时动态模块
    farmRealTimeDynamic: {
      //获取指定农场的经营实时动态列表
      listByFarmId: "/api/produce/co/farmRealTimeDynamic/listByFarmId",
    },
    // 溯源（农业）
    qrCodeAgri: {
      listByFarmId: "/api/produce/co/qrCodeAgri/listByFarmId",
      getByPickId: "/api/produce/co/qrCodeAgri/getByPickId",
    },
    qrCode: {
      listByFarmId: "/api/produce/co/qrCode/listByFarmId",
    },
    // 地块扩展
    landBroaden: {
      // 平台管理-地块扩展管理
      get: "/api/produce/co/landBroaden/get",
    },
    //质量快检
    qualityInspection: {
      companyList: "/api/produce/co/QualityInspectionResult/queryByPage",
      resultList: "/api/produce/co/QualityInspectionResult/queryPage",
      projectItem: "/api/produce/co/QualityInspectionResult/queryCheckProject",
      resultDetail: "/api/produce/co/qualityInspectionInfo",
      bindAdd: "/api/produce/co/QualityLink/insert",
      bindEdit: "/api/produce/co/QualityLink/updateByPrimaryKey",
      bindGet: "/api/produce/co/QualityLink/selectByPrimaryKey",
    },
    // 第三方物联网基础服务模块
    iotAccessThird: {
      getLatestPosition:
        "/api/produce/co/iotAccessThird/device/getLatestPosition",
      deviceBugAnalyHistory:
        "/api/produce/co/iotAccessThird/device/bugAnalyHistory",
      deviceBugList: "/api/produce/co/iotAccessThird/device/bugList",
      deviceBugPicDistinguish:
        "/api/produce/co/iotAccessThird/device/bugPicDistinguish",
      deviceGetBugDataByPicture:
        "/api/produce/co/iotAccessThird/device/getBugDataByPicture",
      deviceGetDetail: "/api/produce/co/iotAccessThird/device/getDetail",
      deviceHistory: "/api/produce/co/iotAccessThird/device/history",
      deviceList: "/api/produce/co/iotAccessThird/device/list",
      deviceSetControllerStatus:
        "/api/produce/co/iotAccessThird/device/setControllerStatus",
      getInsectStatistics:
        "/api/produce/co/iotAccessThird/device/getInsectStatistics",
    },
    // 专家咨询
    expertConsultation: {
      queryPageList: "/api/produce/co/expertConsultationQuery/queryPageList", //查询列表
      quizSave: "/api/produce/co/expertConsultationQuery/save", //专家咨询 新增提问
      updateToRemove: "/api/produce/co/expertConsultationQuery/updateToRemove", //专家咨询 删除提问
      probeSave: "/api/produce/co/expertConsultationAnswer/save", //专家咨询 新增回答/追问
      probeDelete: "/api/produce/co/expertConsultationAnswer/delete", //查询列表
    },
    // 专业版套餐（STORY#3197）支付相关接口 → 见 payment 系统
    proPlan: {
      planRights: "/api/produce/co/proPlan/rights", //权益对比（前端静态，保留占位）
    },
  },
  /* 支付系统（STORY#3197 专业版线上购买；接口文档 /api/payment/v2/api-docs?group=coApi） */
  payment: {
    proPlan: {
      methodList: "/api/payment/co/paymentMethodConfig/list", //可用支付方式
      orderAdd: "/api/payment/co/paymentOrder/add", //创建订单（返回 codeUrl）
      orderGet: "/api/payment/co/paymentOrder/get", //订单详情
      orderPayStatus: "/api/payment/co/paymentOrder/getPayStatus", //支付状态轮询
      orderVerifyPayStatus: "/api/payment/co/paymentOrder/verifyPayStatus", //主动查单（我已支付）
      orderCancel: "/api/payment/co/paymentOrder/cancel", //取消待支付订单
      orderPending: "/api/payment/co/paymentOrder/pending", //待支付订单（复用落库链接）
      orderList: "/api/payment/co/paymentOrder/list", //订单列表
      qualification: "/api/payment/co/paymentOrder/qualification", //企业购买资格与版本状态
      packageList: "/api/payment/co/paymentPackage/list", //订单套餐列表
    },
  },
  /* 用户系统 */
  user: {
    company: {
      get: "/api/user/co/company/get",
      list: "/api/user/co/company/list", // 获取用户具有的企业列表
      add: "/api/user/co/company/v2/add", // 添加企业
      getCompanyInfo: "/api/user/co/company/getRankDetail",
      addByMission: "/api/user/co/user/company/addByMission",
    },
    user: {
      editMyName: "/api/user/co/user/company/editMyName",
      operateList: "/api/user/co/user/company/listInByMission",
    },
    login: {
      logout: "/api/user/co/login/logout",
    },
    hsLogin: {
      login: "/api/user/co/login/password",
    },
    role: {
      permissions: "/api/user/co/role/permissions",
      listByMissionCharge: "/api/user/co/role/listByMissionCharge",
    },
  },
  /** 运营服务 */
  operate: {
    cropPrice: {
      list: "/api/operate/co/crop/price/list",
      listOfCrop: "/api/operate/co/crop/price/listOfCrop",
    },
    crop: {
      list: "/api/operate/co/crop/list",
    },
    // 运营商配置（客服微信二维码 / 联系电话；STORY#3197 权益页「联系客服」）
    subject: {
      get: "/api/operuser/co/operate/subject/get",
    },
  },
  /** 直采系统 **/
  purchase: {
    supplier: {
      get: "/api/purchase/co/supplier/get",
      getWxQrCode: "/api/purchase/co/supplier/getWxQrCode",
      getPagePurchase: "/api/purchase/co/supplier/getPagePurchase",
      getPurchaseById: "/api/purchase/co/supplier/getPurchaseById",
    },
  },
  /** 农机作业 */
  njDispatch: {
    //* 评价模块
    assess: {
      getDetailInfo: "/api/nj/co/njscore/getDetailInfo", //* 评价详情
      getScoreInfo: "/api/nj/co/njscore/getScoreInfo", //* 评价信息
      giveScore: "/api/nj/co/njscore/giveScore", //* 评价
    },
    //* 订单模块
    orderForm: {
      njmap: "/api/nj/co/njorder/get/njmap",
      placeOrder: "/api/nj/co/njorder/placeOrder", //* 下单
      priceEstimate: "/api/nj/co/njorder/priceEstimation", //* 价格估算
      pageList: "/api/nj/co/njorder/pageList", //* 订单列表
      getBaseInfo: "/api/nj/co/njorder/getBaseInfo", //* 详情订单信息
      cancelOrder: "/api/nj/co/njorder/cancelOrder", //* 撤回
      checkServerStation: "/api/nj/co/njorder/checkServerStation", //当前主体下有没有匹配服务站
    },
    //* 农机手模块
    njHand: {
      pageList: "/api/nj/co/manipulator/pageList", //* 意向农机手列表
      listOrderManipulator: "/api/nj/co/manipulator/listOrderManipulator", //* 评价里的农机手列表
    },
    //* 地块模块
    njland: {
      listMissionLand: "/api/nj/co/njland/listMissionLand", //* 详情-任务地块
      listOrderLand: "/api/nj/co/njland/listOrderLand", //* 详情-订单地块
    },
    //* 任务模块
    task: {
      getMissionInfo: "/api/nj/co/njmission/getMissionInfo", //* 农机作业任务
    },
    //* 机械类型
    machinery: {
      subject: "/api/nj/co/worktype/subject/pageList", //* 农机作业任务
      category: "/api/nj/co/worktype/category/pageList", //* 农机作业任务
    },
    //* 农机手投诉
    njcomplaint: {
      addComplaint: "/api/nj/co/njcomplaint/addComplaint", //* 新增投诉
      getComplaintPage: "/api/nj/co/njcomplaint/getComplaintPage", //* 分页查询投诉列表
      getDetailById: "/api/nj/co/njcomplaint/getDetailById", //* 查询投诉详情
      getEnableComplaintManipulator:
        "/api/nj/co/njcomplaint/getEnableComplaintManipulator", //* 获取可投诉农机手
    },
    //* 农忙时间配置
    njbusytime: {
      getConfig: "/api/nj/co/njbusytime/getConfig", //* 查询农忙时间
    },
  },
  //农机服务中心
  njServiceCenter: "/api/njorg/co/company/getByCountyId",
  reslib: {
    njWorkType: {
      listAll: "/api/reslib/co/worktype/listAll", //* 农机作业类型列表
      listCropByWorkType: "/api/reslib/co/worktype/listCropByWorkType", //* 获取作物分组列表
    },
  },
  /*横沙东滩模块接口*/
  hsdt: {
    getFarmInfo: "/api/produce/co/farm/statisticsFarmAcreAndOnPlantingAcre",
    onPlantingByFarmId: "/api/produce/co/farm/onPlantingByFarmId",
    getMissionInfo:
      "/api/produce/co/mission/stasticMissionCategoryByFarmIdAndPeriod",
    getAgriResSku:
      "/api/produce/co/agriResSku/stasticStockValueByFarmIdAndFirstCategory",
  },
};
